import { createApi } from "@reduxjs/toolkit/query/react";

import { API_VALIDATOR_KEYS } from "@/constants/customer-portal/general.constant";
import {
  ICustomerFinance,
  IDashboardData,
} from "@/interfaces/customer-portal/dashboard.interface";
import { BaseWithAuth, getCustomerId } from "@/utils/helpers";

export const C_DashboardApi = createApi({
  reducerPath: "C_DashboardApi",
  baseQuery: BaseWithAuth(),
  tagTypes: [API_VALIDATOR_KEYS.DASHBOARD.BASE],
  endpoints: (builder) => ({
    //get dashboard data
    getCustomerDashboardData: builder.query<IDashboardData, { date?: string }>({
      query: ({ date }) =>
        `customer/${getCustomerId()}/dashboard${date ? date : "?date=" + new Date().toISOString()}`,
      providesTags: [API_VALIDATOR_KEYS.DASHBOARD.BASE],
      transformResponse: (response: APIResponse<IDashboardData>) =>
        response?.data,
    }),

    getCustomerDashboardFinanceSummary: builder.query<
      ICustomerFinance,
      { projectId?: string; date?: string }
    >({
      query: ({ projectId, date }) => {
        const baseUri = `customer/${getCustomerId()}/dashboard/finance`;

        if (projectId && date) {
          return `${baseUri}?projectId=${projectId}&${date}`;
        }
        if (projectId) {
          return `${baseUri}?projectId=${projectId}`;
        }
        if (date) {
          return `${baseUri}?${date}`;
        }

        if (!date) {
          return `${baseUri}?date=${new Date().toISOString()}`;
        }

        return baseUri;
      },
      providesTags: [API_VALIDATOR_KEYS.DASHBOARD.DASHBOARD_FINANCE],
      transformResponse: (response: APIResponse<ICustomerFinance>) =>
        response?.data,
    }),
  }),
});

export const {
  useGetCustomerDashboardDataQuery,
  useGetCustomerDashboardFinanceSummaryQuery,
} = C_DashboardApi;
